<template>
	<p class="has-text-centered has-text-grey is-italic p-4 mb-4">
		<slot />
	</p>
</template>